module.exports = __webpack_public_path__ + "img/action-Reemitere PIN.eb49abc6.svg";